import { template as template_3282f035fb5044429d9498a8b9b7a6cd } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import HelpTooltip from './help-tooltip';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import pick from 'ember-composable-helpers/helpers/pick';
import t from 'ember-intl/helpers/t';
export default template_3282f035fb5044429d9498a8b9b7a6cd(`
  <div class="row">
    <div class="col-lg-4" data-test-first-name>
      <label class="has-tooltip required" for="waitlist-first-name">
        {{t "site.waitlistIntake.fields.legalFirstName"}}
        <HelpTooltip>
          {{t "site.waitlistIntake.tooltips.legalFirstName"}}
        </HelpTooltip>
      </label>
      <RequestValidatedInput @model={{@form}} @path="firstName" @isDirty={{@form.isDirty}}>
        <input
          type="text"
          id="waitlist-first-name"
          name="firstName"
          value={{@form.firstName}}
          {{on "input" (pick "target.value" (fn @onUpdate "firstName"))}}
          autocomplete="given-name"
        />
      </RequestValidatedInput>
    </div>

    <div class="col-lg-4" data-test-last-name>
      <label class="has-tooltip required" for="waitlist-last-name">
        {{t "site.waitlistIntake.fields.legalLastName"}}
        <HelpTooltip>
          {{t "site.waitlistIntake.tooltips.legalLastName"}}
        </HelpTooltip>
      </label>
      <RequestValidatedInput @model={{@form}} @path="lastName" @isDirty={{@form.isDirty}}>
        <input
          type="text"
          id="waitlist-last-name"
          name="lastName"
          value={{@form.lastName}}
          {{on "input" (pick "target.value" (fn @onUpdate "lastName"))}}
          autocomplete="family-name"
        />
      </RequestValidatedInput>
    </div>

    <div class="col-lg-4" data-test-preferred-name>
      <label for="waitlist-preferred-name">
        {{t "site.waitlistIntake.fields.preferredName"}}
      </label>
      <RequestValidatedInput @model={{@form}} @path="preferredName" @isDirty={{@form.isDirty}}>
        <input
          type="text"
          id="waitlist-preferred-name"
          name="preferredName"
          value={{@form.preferredName}}
          {{on "input" (pick "target.value" (fn @onUpdate "preferredName"))}}
          autocomplete="nickname"
        />
      </RequestValidatedInput>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
